import React from 'react';
import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';

// Only rendered once a product actually has materials tagged with more
// than one distinct MIDAS capsule size (see component.js's
// availableCapsuleSizes) — e.g. once Single Unit and Multiunit capsule
// materials both exist on the same product. Sits between "Select your
// device" and "Select material" (auto-numbered like every other
// `.roi-calculator__step`, see style.scss's counter-increment rule), since
// the choice made here determines which materials — and, further down,
// which indications — are available at all.
const CapsuleSizeStep = ( {
	capsuleSizes,
	selectedCapsuleSize,
	onSelectCapsuleSize,
} ) => (
	<div className="roi-calculator__step roi-calculator__step--capsule-size">
		<h3>{ __( 'Select capsule size', 'sprintray-roi-calculator' ) }</h3>
		<p className="roi-calculator__step-hint">
			{ __(
				'Sets which materials and indications are available below.',
				'sprintray-roi-calculator'
			) }
		</p>
		<div className="roi-calculator__capsule-grid">
			{ capsuleSizes.map( ( size ) => (
				<button
					type="button"
					key={ size.value }
					className={
						'roi-calculator__product-card roi-calculator__capsule-card' +
						( size.value === selectedCapsuleSize
							? ' is-selected'
							: '' )
					}
					onClick={ () => onSelectCapsuleSize( size.value ) }
				>
					{ size.label }
				</button>
			) ) }
		</div>
	</div>
);

CapsuleSizeStep.propTypes = {
	capsuleSizes: PropTypes.arrayOf(
		PropTypes.shape( {
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		} )
	).isRequired,
	selectedCapsuleSize: PropTypes.string,
	onSelectCapsuleSize: PropTypes.func.isRequired,
};

export default CapsuleSizeStep;
